import api from './api';

export const budgetService = {
  setBudget: async (data) => {
    return api.post('/budgets', data);
  },

  getMonthBudget: async (month) => {
    return api.get('/budgets', { params: { month } });
  },

  getComparison: async (startMonth, endMonth) => {
    return api.get('/budgets/comparison', { params: { startMonth, endMonth } });
  },

  suggest: async () => {
    return api.get('/budgets/suggest');
  },

  deleteBudget: async ({ categoryId, month }) => {
    return api.delete(`/budgets/${categoryId}/${month}`);
  },
};

export default budgetService;
